import transform from '@/services/gestionMessage/gestionMessageTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'commun/Message/';

export async function getAll(data) {
  const query = transform(data);

  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', query);
  return response;
}

export async function update(message) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', {
    id: message.id,
    message: message.message,
  });
  return response;
}

export async function deleteMessage(message) {
  const response = await HTTP.delete(URL_BASE + 'DeleteAsync', {
    params: {
      id: message.id,
    },
  });
  return response;
}

export async function create(elementId, module, message) {
  const response = await HTTP.post(URL_BASE + 'CreateAsync', {
    elementId: elementId,
    moduleType: module,
    message: message,
  });
  return response;
}

export async function getMessageCount(ids) {
  const response = await HTTP.post(URL_BASE + 'PGetMessagesCountAsync', ids);
  return response;
}
